import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../utils/api";
import { useAuth } from "../AuthContext";
import { detectDevice, detectBrowser, appMode } from "../utils/pwaAnalytics";

// Cookie-free page-view tracking for the Admin analytics tab. Nothing is stored in the
// browser: the server derives an anonymous, daily-changing visitor id from the request,
// so no consent banner is needed. Signed-in visits are attributed from the login token
// (the api client sends it), not from anything the browser claims.

function VisitorTracker() {
  const location = useLocation();
  const { user } = useAuth();

  // Remove the persistent ids older versions of the site stored in the browser.
  useEffect(() => {
    try {
      localStorage.removeItem("ss_visitor_id");
      sessionStorage.removeItem("ss_session_id");
    } catch {
      // storage unavailable (private mode) — nothing to clean up
    }
  }, []);

  useEffect(() => {
    api.post("/api/analytics/visit", {
      pagePath: location.pathname,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
      device: detectDevice(),
      browser: detectBrowser(),
      appMode: appMode(),
    }).catch(() => {
      // silently fail — tracking should never break the app
    });
  }, [location.pathname, user?.userId]);

  return null; // invisible component
}

export default VisitorTracker;
